interface props {
  showErrorContainers: boolean;
  showErrorRequiredFields: boolean;
}

const FooterErrors = ({
  showErrorContainers,
  showErrorRequiredFields,
}: props) => {
  return (
    <>
      <u style={{ color: "red" }}>
        {showErrorContainers === true && (
          <h5>
            Para poder ser creado, el BL debe por lo menos tener un contenedor
            anexado
          </h5>
        )}
      </u>
      <u style={{ color: "red" }}>
        {showErrorRequiredFields === true && (
          <h5>
            Existen campos obligatorios con formato incorrecto o sin introducir
          </h5>
        )}
      </u>
    </>
  );
};

export default FooterErrors;
